import React from 'react'
import Button from './Button'
import Panel from './Panel'
import './styles/distributeEmptyState.scss'

const DistributeEmptyState = ({
    title, subtext, icon, ctaText, ctaIcon, onClick,
}) => (
    <Panel cssClass="distribute-empty-state-container">
        <div className="distribute-empty-state-inset">
            <div className="distribute-empty-state-text-container">
                <div className="distribute-empty-state-icon">
                    <i className={icon} />
                </div>

                <h4>{title}</h4>

                <p>{subtext}</p>

                <Button
                    cssClass="regular primary"
                    onClick={onClick}
                    icon={ctaIcon}
                    label={ctaText}
                />
            </div>
        </div>
    </Panel>
)

export default DistributeEmptyState
